<template>

</template>

<script>
export default {
name: "yieldDetailTabsFour"
}
</script>

<style scoped>

</style>
